module.exports = { id: "whatsapp", url: "/build/app/img/symbols.svg#whatsapp", viewBox: "", toString: function() { return this.url; } };